import React from 'react';
import { Grid, IconButton, Typography } from '@mui/material';
import { AudioCard, AudioCardProps } from './Cards/AudioCard';
import { ISound } from '../../types/global/helper';
import { ThemeStyle } from '../../module/ThemeManager';
import { theme } from '../../constants/theme';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { AddIcon } from '@chakra-ui/icons';

interface AudioListProps extends Pick<AudioCardProps, 'isEditMode' | 'onDelete'> {
    sounds?: ISound[];
    themeStyle: ThemeStyle;
    isEditMode?: boolean;
    onAddNewItem?: VoidFunction;
}

export const AudioReelGrid: React.FC<AudioListProps> = ({ sounds, themeStyle, isEditMode, onAddNewItem, ...props }) => {
    if (!sounds) {
        return <div />;
    }
    return (
        <Grid container spacing={2} mt={2}>
            <Typography
                sx={{ color: theme[themeStyle].tag_white, fontFamily: FONT_ENUM.MAIN_BOLD, fontSize: 16, px: 2 }}>
                Audio Reel
            </Typography>
            {sounds.map((sound, index) => (
                <Grid item xs={12} key={index}>
                    <AudioCard soundData={sound} isEditMode={isEditMode} {...props} />
                </Grid>
            ))}
            {isEditMode && (
                <IconButton
                    onClick={onAddNewItem}
                    sx={{
                        mt: 1,
                        width: '100%',
                        height: 100,
                        backgroundColor: theme[themeStyle].deep_grey_lighter,
                        borderRadius: '10px',
                        '&:hover': { backgroundColor: theme[themeStyle].deep_grey },
                    }}>
                    <AddIcon fontSize="large" sx={{ color: theme[themeStyle].tag_white }} />
                </IconButton>
            )}
        </Grid>
    );
};
